import React, { useContext, useEffect, useState } from "react";
import styles from './VacanciePreviewPage.module.scss'
import cn from 'classnames'
import gs from "../../Layout.module.scss";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { Vacancies } from "../../content/vacancies";
import { getVacancies } from "../../service/service";
import { LangContext } from "../../store/LangContext";
import useDebounce from "../../utils/use-debounce";
import { Vacancy } from "../../types/vacancy";
import Button from "react-bootstrap/esm/Button";
import loaderIcon from "../../static/loader.svg";
import TimeIcon from "../../static/time.svg";
import MoneyIcon from "../../static/money.svg";
import StarIcon from "../../static/star.svg";
import LocationIcon from "../../static/location.svg";
import ArrowRight from "../../static/arrow_right.svg";
import ArrowRightWhite from "../../static/arrow_right_white.svg";
import ArrowLeft from '../../static/arrow_left.svg'

function VacanciePreviewPage() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const vacancyId = JSON.parse(searchParams.get('vacancyId') ?? '')
    const lang = useContext(LangContext)
    const debounceLang = useDebounce(lang, 100);
    const formatMoney = (amount: string) => {
        if (amount.split(".")[1]?.length < 2) {
            return amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "0";
        }
        return amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };
    const [vacanciesJson, setVacanciesJson] = useState<Vacancy[]>([]);
    useEffect(() => {
        if (lang)
            getVacancies(debounceLang).then((response) => {
                setVacanciesJson(response);
            });
    }, [debounceLang]);
    const schedulesEnum = [
        {
            value: 1,
            label: "2/2",
        },
        {
            value: 2,
            label: "5/2",
        },
        {
            value: 3,
            label: Vacancies.partTime[lang],
        },
        {
            value: 4,
            label: Vacancies.flexible[lang],
        },
        {
            value: 5,
            label: Vacancies.shiftwork[lang],
        },
        {
            value: 6,
            label: Vacancies.remotely[lang],
        },
        {
            value: 7,
            label: Vacancies.shiftMethod[lang],
        },
    ];
    const vacancyData = vacanciesJson.find((e) => e.id === vacancyId)
    const prerequisites = [vacancyData?.showCar && "hasACar", vacancyData?.showPortfolio && "portfolio", vacancyData?.showResume && "resume"].filter((e) => e);
    const prerequisitesTranslate = prerequisites.map((e) => {
        return Vacancies[e as "hasACar" | "portfolio" | "resume"][lang].toLowerCase();
    });
    function onClickHandle() {
        navigate({
            pathname: `/vacancie`,
            search: createSearchParams({
                lang: lang,
                vacancyId: JSON.stringify(vacancyData?.id),
                showCar: JSON.stringify(vacancyData?.showCar),
                showPortfolio: JSON.stringify(vacancyData?.showPortfolio),
                showResume: JSON.stringify(vacancyData?.showResume),
                positionCandidate: JSON.stringify(vacancyData?.vacancyName),
                knowledgeLang: JSON.stringify(vacancyData?.languages.filter((item: any) => item.length > 0)),
                driverLicenses: JSON.stringify(vacancyData?.driverLicenses.filter((item: any) => item.length > 0)),
                schedule: JSON.stringify(vacancyData?.schedule)
            }).toString()
        })
    }
    return vacancyData ? <div>
        <div className={styles.header_title}>
            <img className={styles.mobile_header_btn} src={ArrowLeft} alt="back" onClick={() => navigate({
                    pathname: `/`
                })} />
            <h1>{vacancyData.vacancyName}</h1>
            <Button
                className={styles.header_btn}
                variant="primary"
                onClick={() => navigate({
                    pathname: `/`
                })}
            >
                <span>{Vacancies.toOtherVacancies[lang]}</span>
                <img src={ArrowRight} alt="arrow" />
            </Button>
        </div>
        <div className={styles.header_box}>
            <div className={styles.header_box_item}>
                <img src={LocationIcon} alt="location" />
                <span>{vacancyData?.affiliate}</span>
            </div>
            <div className={styles.header_box_item}>
                <img src={MoneyIcon} alt="money" />
                <div>
                    <span className={styles.gray}>{Vacancies.salary[lang]}: </span>
                    <span>{vacancyData?.salaryType === 0
                        ? Vacancies.from[lang] + " " + formatMoney(vacancyData?.salary?.toString() ?? "")
                        : vacancyData?.salaryType === 1
                            ? Vacancies.to[lang] + " " + formatMoney(vacancyData?.salary?.toString() ?? "")
                            : vacancyData?.salaryType === 2
                                ? formatMoney(vacancyData?.salary?.toString() ?? "")
                                : null}{" "}
                        {vacancyData?.currencySign}</span>
                </div>
            </div>
            <div className={styles.header_box_item}>
                <img src={StarIcon} alt="start" />
                <div>
                    <span className={styles.gray}>{Vacancies.experience[lang]}: </span>
                    <span>{vacancyData?.experience}</span>
                </div>
            </div>
            <div className={styles.header_box_item}>
                <img src={TimeIcon} alt="time" />
                <div>
                    <span className={styles.gray}>{Vacancies.schedule[lang]}: </span>
                    <span>{schedulesEnum.find((e) => e.value === +(vacancyData?.schedule ?? ''))?.label}</span>
                </div>
            </div>
        </div>
        <div className={styles.vacancy_section}>
            <Button
                className={styles.btn}
                variant="primary"
                onClick={onClickHandle}
            >
                <span>{Vacancies.respond[lang]}</span>
                <img src={ArrowRightWhite} alt="arrow" />
            </Button>
            {/* {prerequisitesTranslate.length > 0 || vacancyData?.driverLicenses?.filter((item: any) => item.length > 0)?.length > 0 || vacancyData?.languages?.filter((item: any) => item.length > 0)?.length > 0 ? (
                <p>
                    <b>{Vacancies.prerequisites[lang]}:</b> {prerequisitesTranslate.join(", ")}
                    {prerequisitesTranslate.length > 0 && (vacancyData?.driverLicenses?.filter((item: any) => item.length > 0)?.length > 0 || vacancyData?.languages?.filter((item: any) => item.length > 0)?.length > 0) ? ", " : null}
                    {vacancyData?.driverLicenses?.filter((item: any) => item.length > 0)?.length > 0 ? Vacancies.haveLicense[lang] + ": " + vacancyData?.driverLicenses.join(", ") : null}
                    {vacancyData?.driverLicenses?.filter((item: any) => item.length > 0)?.length > 0 && vacancyData?.languages?.filter((item: any) => item.length > 0)?.length > 0 ? ", " : null}
                    {vacancyData?.languages?.filter((item: any) => item.length > 0)?.length > 0 ? Vacancies.knowledgeLang[lang] + ": " + vacancyData?.languages.map((l) => Vacancies[l as "RUS" | "ENG" | "KZ"]?.[lang]?.toLowerCase())?.join(", ") : null}
                </p>
            ) : null} */}
            <div className={styles.vacancy_section_item}>
                <b>{Vacancies.description[lang]}:</b>
                <pre>{vacancyData?.responsibilities}</pre>
            </div>
            <div className={styles.vacancy_section_item}>
                <b>{Vacancies.requirements[lang]}:</b>
                <pre>{vacancyData?.requirements}</pre>
            </div>
            <div className={styles.vacancy_section_item}>
                <b>{Vacancies.additionally[lang]}:</b>
                <pre>{vacancyData?.additionally}</pre>
            </div>
            <div className={styles.vacancy_section_item}>
                <b>{Vacancies.conditions[lang]}:</b>
                <pre>{vacancyData?.workingConditions}</pre>
            </div>
            <Button
                className={styles.btn}
                variant="primary"
                onClick={onClickHandle}
            >
                <span>{Vacancies.respond[lang]}</span>
                <img src={ArrowRight} alt="arrow" />
            </Button>
        </div>
    </div> : <div className={styles.loaderBox}>
        <img width={40} src={loaderIcon} className={gs.loader} />
    </div>
}

export default VacanciePreviewPage